import { useState }                      from 'react';
import { Route, NavLink, Switch }        from 'react-router-dom';
import { Breadcrumb, BreadcrumbDivider } from 'semantic-ui-react';
import AllRuns                           from './Runs';
import SingleRun                         from './SingleRun';

function Runs() {
	const [ selected_run_name, setSelectedRunName ] = useState(``);

	function handleSetName(name) {
		setSelectedRunName(name);
	}

	return (
		<div>
			<Breadcrumb size="small">
				<Breadcrumb.Section link as={NavLink} to="/runs">Runs</Breadcrumb.Section>
				{selected_run_name ? (
					<>
						<BreadcrumbDivider icon='right chevron' />
						<Breadcrumb.Section active>
							{selected_run_name}
						</Breadcrumb.Section>
					</>
				) : null}
			</Breadcrumb>

			<Switch>
				<Route exact path="/runs">
					<AllRuns
						handleSetName={handleSetName}
					/>
				</Route>

				<Route exact path="/runs/:id">
					<SingleRun
						handleSetName={handleSetName}
					/>
				</Route>
			</Switch>
		</div>
	);
}

export default Runs;
